import { Remote } from 'rustig';

export class HandlesItemRefresh {
  public static execute(data: Options): void {
    let context = data.contextSelector == null ? document : document.querySelector(data.contextSelector);
    let item = context.querySelector(data.itemSelector);
    let itemExists = item != null;
    let url = null;

    if (!data.shouldExist && itemExists) {
      url = data.refreshResultsUrl;
    }
    else if (data.shouldExist && itemExists) {
      url = data.refreshItemUrl;
    }
    else if (data.shouldExist && !itemExists) {
      url = data.refreshResultsUrl;
    }

    if (url == null)
      return;

    Remote.execute($(document.body), { url: url });
  }
}

interface Options {
  itemSelector: string,
  shouldExist: boolean,
  refreshItemUrl: string,
  refreshResultsUrl: string,
  contextSelector?: string
}